// Import style
import {
    ProductDetailsContainer,
    ProductTitle,
    ProductDescription,
    ProductPrice,
    EditButton,
    Icon,
} from './style';

// Import components
import ProductSlideShow from '../../components/ProductSlideShow';

// Import assets
import { ReactComponent as modifyIcon } from '../../assets/icons/settings.svg';

// Component to display product détails
function ProductDetails({
    ICON_WIDTH = 30,
    name = '',
    description = '',
    images = null,
    offer = false,
    price = '',
    isAdmin = false,
    onEdit = null,
}) {
    return (
        <ProductDetailsContainer>
            {isAdmin && (
                <EditButton onClick={() => onEdit()}>
                    <Icon as={modifyIcon} width={ICON_WIDTH} />
                </EditButton>
            )}
            <ProductTitle>{name}</ProductTitle>
            <ProductSlideShow
                ICON_WIDTH={ICON_WIDTH}
                productName={name}
                images={
                    images && images.length > 0
                        ? images.map((image) => image.url)
                        : null
                }
                offer={offer}
            />
            <ProductDescription>{description}</ProductDescription>
            <ProductPrice>{price} $</ProductPrice>
        </ProductDetailsContainer>
    );
}

export default ProductDetails;
